import { BurgerButtonProps } from "./types";

export function BurgerButton({ isOpen, onClick }: BurgerButtonProps) {
  return (
    <div
      onClick={onClick}
      className="fixed top-2 right-4 w-12 h-12 flex items-center justify-center focus:outline-none z-50 bg-white cursor-pointer"
      aria-label="Toggle menu"
    >
      <span
        className={`absolute block h-0.5 w-[30px] bg-current transition-transform duration-300 ease-in-out origin-center ${
          isOpen ? "rotate-45 translate-y-0" : "-translate-y-2"
        }`}
        style={{ top: "50%" }}
      />

      <span
        className={`absolute block h-0.5 w-[30px] bg-current transition-transform duration-300 ease-in-out origin-center ${
          isOpen ? "opacity-0" : "translate-y-0"
        }`}
        style={{ top: "50%" }}
      />

      <span
        className={`absolute block h-0.5 w-[30px] bg-current transition-transform duration-300 ease-in-out origin-center ${
          isOpen ? "-rotate-45 translate-y-0" : "translate-y-2"
        }`}
        style={{ top: "50%" }}
      />
    </div>
  );
}
